import Cookies from 'js-cookie';
import { ECookieKey } from '@/enums';

/**
 * Get cookie options based on the remember_me preference
 * @returns Cookie options with appropriate expiration time
 */
export const getCookieOptions = () => {
  const remember_me = Cookies.get(ECookieKey.REMEMBER_ME);
  return remember_me === 'true' ? { expires: 14 } : { expires: 1 };
};

/**
 * Update organization and workspace cookies with proper expiration
 * @param organizationId - The organization UUID
 * @param workspaceId - The workspace UUID
 */
export const updateOrgWorkspaceCookies = (organizationId: string, workspaceId: string) => {
  const options = getCookieOptions();
  Cookies.set(ECookieKey.MAIN_ORGANIZATION, organizationId, options);
  Cookies.set(ECookieKey.FALLBACK_WORKSPACE, workspaceId, options);
};
